import React, { useState } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import img1 from '../Components/Images/esl/inst1.png'
import img2 from '../Components/Images/esl/inst2.png'
import img3 from '../Components/Images/esl/inst3.png'
import img4 from '../Components/Images/esl/inst4.png'
import img5 from '../Components/Images/esl/inst5.png'
import img6 from '../Components/Images/esl/inst6.png'
import img7 from '../Components/Images/esl/inst7.png'
import img8 from '../Components/Images/esl/inst8.png'
import img9 from '../Components/Images/esl/inst9.png'
import img10 from '../Components/Images/esl/inst10.png'


const ImageGallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Sample images data - replace with your actual images
  const images = [
    {
      id: 1,
      main: img1,
      title: 'Hypermarkets',
      subtitle: 'Learn More',
      category: 'hypermarket'
    },
    {
      id: 2,
      main: img2,
      title: 'Green Grocer',
      subtitle: 'Explore More',
      category: 'green grocer'
    },
    {
      id: 3,
      main: img3,
      title: 'Fruits store',
      subtitle: 'Discover More',
      category: 'fruits store'
    },
    {
      id: 4,
      main: img4,
      title: 'Fashion',
      subtitle: 'Shop Now',
      category: 'beauty'
    },
    {
      id: 5,
      main: img5,
      title: 'Grocery',
      subtitle: 'Get Active',
      category: 'grocery'
    },
    {
      id: 6,
      main: img6,
      title: 'PET Shops',
      subtitle: 'Read More',
      category: 'pet shops'
    },
    {
      id: 7,
      main: img7,
      title: 'Beverages',
      subtitle: 'Cook Better',
      category: 'beverages'
    },
    {
      id: 8,
      main: img8,
      title: 'Meat shop',
      subtitle: 'Innovation Hub',
      category: 'Meat'
    },
    {
      id: 9,
      main: img9,
      title: 'ESL Aqua',
      subtitle: 'Look Great',
      category: 'Aqua'
    },
    {
      id: 10,
      main: img10,
      title: 'Pharmacy',
      subtitle: 'Drive Forward',
      category: 'pharmacy'
    },
    {
      id: 11,
      main: img3,
      title: 'Fruits Store',
      subtitle: 'Play Time',
      category: 'fruits store'
    },
    {
      id: 12,
      main: img4,
      title: 'Fashion',
      subtitle: 'Stay Fit',
      category: 'beauty'
    }
  ];

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // Get images for right side grid (4 images visible at a time)
  const getRightSideImages = () => {
    const rightImages = [];
    for (let i = 0; i < 4; i++) {
      const index = (currentIndex + i + 1) % images.length;
      rightImages.push(images[index]);
    }
    return rightImages;
  };

  const rightSideImages = getRightSideImages();
  const currentImage = images[currentIndex];

  return (
    <div className="container-fluid p-5 mb-5" style={{ height: '75vh', background: '#f8f9fa' }}>
      <div className="row g-0 h-100 ">
        <div className='pl-3'>
                <h2>Hanshow ESL Solutions are Perfect for:</h2>
              </div>
        {/* Left Side - Main Image */}
        <div className="col-lg-7 position-relative pl-2">
          <div 
            className="h-100 d-flex align-items-end position-relative"
            style={{
              backgroundImage: `url(${currentImage.main})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            {/* Overlay */}
            <div 
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background: 'linear-gradient(135deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.4) 100%)'
              }}
            ></div>
            
            {/* Content */}
            <div className="p-5 text-white position-relative z-index-1">
              <h1 
                className="display-4 fw-bold mb-3"
                style={{ 
                  fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                }}
              >
                {currentImage.title}
              </h1>
              <button 
                className="btn btn-outline-light btn-lg px-4 py-2 rounded-pill"
                style={{
                  borderWidth: '2px',
                  fontWeight: '500',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.color = '#333';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = 'white';
                }}
              >
                {currentImage.subtitle}
              </button>
            </div>
          </div>
        </div>

        {/* Right Side - Image Grid with Navigation */}
        <div className="col-lg-5 bg-white position-relative">
          <div className="h-100 d-flex flex-column">
            {/* Image Grid */}
            <div className="flex-grow-1 p-3">
              <div className="row g-3 h-100">
                {rightSideImages.map((image, index) => (
                  <div key={image.id} className="col-6">
                    <div 
                      className="position-relative h-100 rounded-3 overflow-hidden shadow-sm cursor-pointer"
                      style={{
                        minHeight: index < 2 ? '200px' : '180px',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onClick={() => setCurrentIndex((currentIndex + index + 1) % images.length)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                      }}
                    >
                      <img
                        src={image.main}
                        alt={image.title}
                        className="w-100 h-100"
                        style={{ objectFit: 'cover' }}
                      />
                      
                      {/* Overlay with title */}
                      <div 
                        className="position-absolute bottom-0 start-0 w-100 p-3"
                        style={{
                          background: 'linear-gradient(transparent, rgba(0,0,0,0.7))'
                        }}
                      >
                        <h6 className="text-white mb-0 fw-bold" style={{ fontSize: '0.9rem' }}>
                          {image.title}
                        </h6>
                      </div>

                      {/* Special badges for certain categories */}
                      {(image.category === 'beverages' || image.category === 'pharmacy') && (
                        <div 
                          className="position-absolute top-2 start-2 bg-primary text-white px-2 py-1 rounded-2"
                          style={{ fontSize: '0.7rem', fontWeight: 'bold' }}
                        >
                          {image.category.toUpperCase()}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="position-absolute end-0 top-50 translate-middle-y me-3">
            <div className="d-flex flex-column gap-2">
              <button
                className="btn btn-primary rounded-circle p-2 shadow-lg"
                onClick={handlePrev}
                style={{
                  width: '50px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.1)';
                  e.target.style.boxShadow = '0 6px 20px rgba(13, 110, 253, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                }}
              >
                <ChevronUp size={20} />
              </button>
              
              <button
                className="btn btn-primary rounded-circle p-2 shadow-lg"
                onClick={handleNext}
                style={{
                  width: '50px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.1)';
                  e.target.style.boxShadow = '0 6px 20px rgba(13, 110, 253, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                }}
              >
                <ChevronDown size={20} />
              </button>
            </div>
          </div>

          {/* Image Counter */}
          {/* <div className="position-absolute bottom-0 start-0 w-100 p-3">
            <div className="text-center">
              <small className="text-muted">
                {currentIndex + 1} of {images.length}
              </small>
              <div className="mt-2">
                <div 
                  className="bg-light rounded-pill mx-auto"
                  style={{ height: '4px', width: '100px' }}
                >
                  <div 
                    className="bg-primary rounded-pill h-100 transition-all"
                    style={{ 
                      width: `${((currentIndex + 1) / images.length) * 100}%`,
                      transition: 'width 0.3s ease'
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <style jsx>{`
        .cursor-pointer {
          cursor: pointer;
        }
        .z-index-1 {
          z-index: 1;
        }
        .transition-all {
          transition: all 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default ImageGallery;